// src/services/totalityService.ts

import { Decimal } from 'decimal.js';

Decimal.set({ precision: 200 });

export class AZLEngine {
  private epsilon: Decimal;
  public vault: any[] = [];
  
  constructor(depth: number = 100) {
    this.epsilon = new Decimal(10).pow(new Decimal(-depth));
  }

  private _num(v: number | string | Decimal): Decimal {
    return new Decimal(v);
  }

  private _eq(a: number | string | Decimal, b: number | string | Decimal): boolean {
    return this._num(a).sub(this._num(b)).abs().lt(this.epsilon);
  }

  public ID(value: number | string | Decimal, name: string = "", domain: string = "") {
    const v = this._num(value);
    const entry = {
      name, domain, input: v,
      azl_id: v,
      type: this._eq(v, 0) ? "VOID" : "SOMETHING",
      logic: this._eq(v, 0) ? "0=void" : "exact"
    };
    this.vault.push(entry);
    return entry;
  }

  public MUL(a: number | string | Decimal, b: number | string | Decimal, name: string = "", domain: string = "") {
    const idA = this.ID(a, "A", domain);
    const idB = this.ID(b, "B", domain);

    if (idA.type === "VOID") {
      const res = this.ID(0, name, domain);
      return { ...res, logic: "0xN=0", action: "0×N=0: Void deletion" };
    }

    if (idB.type === "VOID") {
      const res = this.ID(idA.azl_id, name, domain);
      return { ...res, logic: "Nx0=N", action: "N×0=N: Preservation" };
    }

    if (this._eq(a, 1) && this._eq(b, 1)) {
      const res = this.ID(2, name, domain);
      return { ...res, logic: "1x1=2", action: "1×1=2: Creation" };
    }

    const raw = idA.azl_id.add(idB.azl_id);
    const res = this.ID(raw, name, domain);
    return { ...res, logic: "sum" };
  }
}
